const translations = {
  nl: {
    nav: {
      services: "Diensten",
      dashboard: "Dashboard",
      admin: "Admin",
      login: "Inloggen",
      register: "Registreren",
      logout: "Uitloggen",
    },
    hero: {
      badge: "33% van NL-bedrijven gebruikt al AI — u ook?",
      title: "Van losse AI-experimenten naar werkende processen",
      subtitle: "Wij helpen middelgrote bedrijven AI praktisch in te bouwen in bestaande werkprocessen. Sneller werken, minder fouten, meer grip op kennis en uitvoering.",
      cta_scan: "Vraag een Gratis AI Scan aan",
      cta_services: "Bekijk onze diensten",
      stat_ai: "van NL-bedrijven gebruikt AI",
      stat_days: "tot meetbaar resultaat",
      stat_fte: "FTE doelgroep",
      stat_exp: "jaar internationale ervaring",
    },
    services: {
      title: "Onze Diensten",
      subtitle: "Praktische AI-oplossingen die direct resultaat opleveren",
      start_intake: "Start Intake",
      per_project: "per project",
    },
    approach: {
      title: "Onze Aanpak",
      subtitle: "Drie beloftes, een doel: uw bedrijf slimmer laten werken",
      promise1_title: "Efficienter werken",
      promise1_desc: "Wij halen repetitief kantoorwerk uit processen. Minder tijd kwijt aan administratie, e-mail, documenten en rapportages.",
      promise2_title: "Commercieel sneller groeien",
      promise2_desc: "Sales- en serviceteams reageren sneller, volgen beter op en halen meer uit klantdata.",
      promise3_title: "Grip en standaardisatie",
      promise3_desc: "Kennis, werkwijzen en communicatie worden consistenter met AI. Ideaal voor bedrijven met meerdere teams of vestigingen.",
      usecases_title: "10 use cases die elk bedrijf begrijpt",
      usecases: [
        "E-mails samenvatten en prioriteren",
        "Offertes en voorstellen sneller opstellen",
        "Klantvragen automatisch categoriseren",
        "Interne kennisbank / AI-assistent",
        "Rapportages en samenvattingen maken",
        "Documenten uitlezen en data overnemen",
        "CRM-notities en sales follow-up",
        "Meeting notes en actiepunten genereren",
        "Vacatureteksten en onboardingmateriaal",
        "Contracten en beleidsdocumenten analyseren"
      ],
    },
    sectors: {
      title: "Sectoren",
      subtitle: "Waar AI het snelst zichtbaar resultaat oplevert",
      items: [
        { name: "Zakelijke Dienstverlening", desc: "Consultancy, accountancy, juridisch, HR" },
        { name: "Groothandel & B2B Sales", desc: "Handel, distributie, B2B verkooporganisaties" },
        { name: "Logistiek & Supply Chain", desc: "Transport, warehousing, planning" },
        { name: "Productie & Maakindustrie", desc: "Fabricage, assemblage, kwaliteitscontrole" },
        { name: "Bouw & Technische Service", desc: "Installatie, onderhoud, projecten" },
        { name: "HR & Recruitment", desc: "Werving, selectie, onboarding" },
      ],
    },
    cta: {
      title: "Klaar om AI praktisch in te zetten?",
      subtitle: "Vraag een gratis AI Quick Scan aan. In 2-3 weken laten wij zien waar AI direct rendement oplevert in uw organisatie.",
      benefits: [
        "Gratis en vrijblijvend kennismakingsgesprek",
        "Top-10 AI-kansen voor uw organisatie",
        "Verwachte tijdsbesparing per proces",
        "Concrete 90-dagen roadmap",
      ],
      button: "Start uw Gratis AI Scan",
    },
    auth: {
      login_title: "Welkom terug",
      login_subtitle: "Log in op uw CleverTion account",
      register_title: "Account aanmaken",
      register_subtitle: "Start met uw AI-transformatie",
      email: "E-mailadres",
      password: "Wachtwoord",
      name: "Volledige naam",
      login_btn: "Inloggen",
      register_btn: "Registreren",
      google_btn: "Doorgaan met Google",
      no_account: "Nog geen account?",
      has_account: "Al een account?",
      or: "of",
    },
    dashboard: {
      title: "Mijn Dashboard",
      tab_overview: "Overzicht",
      tab_intakes: "Mijn Aanvragen",
      tab_reports: "Rapporten",
      welcome: "Welkom",
      no_intakes: "U heeft nog geen aanvragen. Kies een dienst om te beginnen.",
      no_reports: "Er zijn nog geen rapporten beschikbaar.",
      choose_service: "Kies een dienst",
      status: "Status",
      payment: "Betaling",
      report: "Rapport",
      view_report: "Bekijk Rapport",
      generate_report: "Genereer Rapport",
      pay_now: "Nu Betalen",
      generating: "Rapport wordt gegenereerd...",
      paid: "Betaald",
      pending: "In afwachting",
      submitted: "Ingediend",
      completed: "Voltooid",
      not_started: "Nog niet gestart",
    },
    intake: {
      title: "Intake Formulier",
      submit: "Verstuur Aanvraag",
      submitting: "Bezig met versturen...",
      required: "Dit veld is verplicht",
      select_placeholder: "Selecteer...",
      success: "Uw aanvraag is succesvol ingediend!",
      proceed_payment: "Ga naar betaling",
      back: "Terug naar dashboard",
    },
    admin: {
      title: "Admin Dashboard",
      tab_stats: "Statistieken",
      tab_clients: "Klanten",
      tab_pipeline: "CRM Pipeline",
      tab_intakes: "Aanvragen",
      tab_reports: "Rapporten",
      tab_payments: "Betalingen",
      total_clients: "Totaal klanten",
      active_clients: "Actieve klanten",
      blocked_clients: "Geblokkeerde klanten",
      total_intakes: "Totaal aanvragen",
      paid_intakes: "Betaalde aanvragen",
      total_reports: "Totaal rapporten",
      total_revenue: "Totale omzet",
      block: "Blokkeren",
      accept: "Accepteren",
      blocked: "Geblokkeerd",
      active: "Actief",
      move_to: "Verplaats naar",
      stages: {
        lead: "Lead",
        quick_scan: "Quick Scan",
        pilot: "Pilot",
        workflow: "Workflow",
        training: "Training",
        governance: "Governance",
      },
    },
    payment: {
      checking: "Betalingsstatus wordt gecontroleerd...",
      success: "Betaling succesvol!",
      success_msg: "Uw betaling is ontvangen. U kunt nu uw rapport laten genereren.",
      failed: "Betaling mislukt",
      failed_msg: "Er is een probleem opgetreden met uw betaling. Probeer het opnieuw.",
      go_dashboard: "Ga naar Dashboard",
    },
    footer: {
      tagline: "Slim AI in actie voor uw bedrijf",
      rights: "Alle rechten voorbehouden.",
    },
  },
  en: {
    nav: {
      services: "Services",
      dashboard: "Dashboard",
      admin: "Admin",
      login: "Login",
      register: "Register",
      logout: "Logout",
    },
    hero: {
      badge: "33% of Dutch companies already use AI — do you?",
      title: "From standalone AI experiments to working processes",
      subtitle: "We help mid-sized companies practically integrate AI into existing work processes. Work faster, fewer errors, more control over knowledge and execution.",
      cta_scan: "Request a Free AI Scan",
      cta_services: "View our services",
      stat_ai: "of Dutch companies use AI",
      stat_days: "to measurable results",
      stat_fte: "FTE target group",
      stat_exp: "years international experience",
    },
    services: {
      title: "Our Services",
      subtitle: "Practical AI solutions that deliver immediate results",
      start_intake: "Start Intake",
      per_project: "per project",
    },
    approach: {
      title: "Our Approach",
      subtitle: "Three promises, one goal: making your business work smarter",
      promise1_title: "Work more efficiently",
      promise1_desc: "We remove repetitive office work from processes. Less time on administration, email, documents and reporting.",
      promise2_title: "Grow commercially faster",
      promise2_desc: "Sales and service teams respond faster, follow up better and get more from customer data.",
      promise3_title: "Control and standardization",
      promise3_desc: "Knowledge, methods and communication become more consistent with AI. Ideal for companies with multiple teams or locations.",
      usecases_title: "10 use cases every company understands",
      usecases: [
        "Summarize and prioritize emails",
        "Draft quotes and proposals faster",
        "Automatically categorize customer inquiries",
        "Internal knowledge base / AI assistant",
        "Create reports and summaries",
        "Read documents and transfer data",
        "CRM notes and sales follow-up",
        "Generate meeting notes and action items",
        "Job descriptions and onboarding material",
        "Analyze contracts and policy documents"
      ],
    },
    sectors: {
      title: "Sectors",
      subtitle: "Where AI delivers the fastest visible results",
      items: [
        { name: "Business Services", desc: "Consultancy, accounting, legal, HR" },
        { name: "Wholesale & B2B Sales", desc: "Trade, distribution, B2B sales organizations" },
        { name: "Logistics & Supply Chain", desc: "Transport, warehousing, planning" },
        { name: "Manufacturing & Industry", desc: "Production, assembly, quality control" },
        { name: "Construction & Technical Service", desc: "Installation, maintenance, projects" },
        { name: "HR & Recruitment", desc: "Recruitment, selection, onboarding" },
      ],
    },
    cta: {
      title: "Ready to put AI to work?",
      subtitle: "Request a free AI Quick Scan. In 2-3 weeks we show you where AI delivers immediate returns in your organization.",
      benefits: [
        "Free and non-binding consultation",
        "Top-10 AI opportunities for your organization",
        "Expected time savings per process",
        "Concrete 90-day roadmap",
      ],
      button: "Start your Free AI Scan",
    },
    auth: {
      login_title: "Welcome back",
      login_subtitle: "Log in to your CleverTion account",
      register_title: "Create account",
      register_subtitle: "Start your AI transformation",
      email: "Email address",
      password: "Password",
      name: "Full name",
      login_btn: "Login",
      register_btn: "Register",
      google_btn: "Continue with Google",
      no_account: "Don't have an account?",
      has_account: "Already have an account?",
      or: "or",
    },
    dashboard: {
      title: "My Dashboard",
      tab_overview: "Overview",
      tab_intakes: "My Submissions",
      tab_reports: "Reports",
      welcome: "Welcome",
      no_intakes: "You have no submissions yet. Choose a service to get started.",
      no_reports: "No reports available yet.",
      choose_service: "Choose a service",
      status: "Status",
      payment: "Payment",
      report: "Report",
      view_report: "View Report",
      generate_report: "Generate Report",
      pay_now: "Pay Now",
      generating: "Generating report...",
      paid: "Paid",
      pending: "Pending",
      submitted: "Submitted",
      completed: "Completed",
      not_started: "Not started",
    },
    intake: {
      title: "Intake Form",
      submit: "Submit Request",
      submitting: "Submitting...",
      required: "This field is required",
      select_placeholder: "Select...",
      success: "Your request has been successfully submitted!",
      proceed_payment: "Proceed to payment",
      back: "Back to dashboard",
    },
    admin: {
      title: "Admin Dashboard",
      tab_stats: "Statistics",
      tab_clients: "Clients",
      tab_pipeline: "CRM Pipeline",
      tab_intakes: "Submissions",
      tab_reports: "Reports",
      tab_payments: "Payments",
      total_clients: "Total clients",
      active_clients: "Active clients",
      blocked_clients: "Blocked clients",
      total_intakes: "Total submissions",
      paid_intakes: "Paid submissions",
      total_reports: "Total reports",
      total_revenue: "Total revenue",
      block: "Block",
      accept: "Accept",
      blocked: "Blocked",
      active: "Active",
      move_to: "Move to",
      stages: {
        lead: "Lead",
        quick_scan: "Quick Scan",
        pilot: "Pilot",
        workflow: "Workflow",
        training: "Training",
        governance: "Governance",
      },
    },
    payment: {
      checking: "Checking payment status...",
      success: "Payment successful!",
      success_msg: "Your payment has been received. You can now generate your report.",
      failed: "Payment failed",
      failed_msg: "There was a problem with your payment. Please try again.",
      go_dashboard: "Go to Dashboard",
    },
    footer: {
      tagline: "Smart AI in action for your business",
      rights: "All rights reserved.",
    },
  },
  de: {
    nav: { services: "Dienste", dashboard: "Dashboard", admin: "Admin", login: "Anmelden", register: "Registrieren", logout: "Abmelden" },
    hero: {
      badge: "33% der NL-Unternehmen nutzen bereits KI \u2014 Sie auch?",
      title: "Von einzelnen KI-Experimenten zu funktionierenden Prozessen",
      subtitle: "Wir helfen mittelst\u00e4ndischen Unternehmen, KI praktisch in bestehende Arbeitsprozesse zu integrieren.",
      cta_scan: "Kostenlosen KI-Scan anfordern",
      cta_services: "Unsere Dienste ansehen",
      stat_ai: "der NL-Unternehmen nutzen KI",
      stat_days: "bis zum messbaren Ergebnis",
      stat_fte: "FTE Zielgruppe",
      stat_exp: "Jahre internationale Erfahrung",
    },
    services: { title: "Unsere Dienste", subtitle: "Praktische KI-L\u00f6sungen mit sofortigem Ergebnis", start_intake: "Intake starten", per_project: "pro Projekt" },
    approach: {
      title: "Unser Ansatz", subtitle: "Drei Versprechen, ein Ziel: Ihr Unternehmen klugier arbeiten lassen",
      promise1_title: "Effizienter arbeiten", promise1_desc: "Wir entfernen repetitive B\u00fcroarbeit aus Prozessen.",
      promise2_title: "Kommerziell schneller wachsen", promise2_desc: "Vertriebs- und Serviceteams reagieren schneller und holen mehr aus Kundendaten.",
      promise3_title: "Kontrolle und Standardisierung", promise3_desc: "Wissen, Methoden und Kommunikation werden mit KI konsistenter.",
      usecases_title: "10 Anwendungsf\u00e4lle, die jedes Unternehmen versteht",
      usecases: ["E-Mails zusammenfassen und priorisieren", "Angebote und Vorschl\u00e4ge schneller erstellen", "Kundenanfragen automatisch kategorisieren", "Interne Wissensdatenbank / KI-Assistent", "Berichte und Zusammenfassungen erstellen", "Dokumente auslesen und Daten \u00fcbernehmen", "CRM-Notizen und Vertriebs-Follow-up", "Meeting-Notizen und Aktionspunkte generieren", "Stellenbeschreibungen und Onboarding-Material", "Vertr\u00e4ge und Richtliniendokumente analysieren"],
    },
    sectors: {
      title: "Sektoren", subtitle: "Wo KI am schnellsten sichtbare Ergebnisse liefert",
      items: [
        { name: "Gesch\u00e4ftsdienstleistungen", desc: "Beratung, Buchhaltung, Recht, HR" },
        { name: "Gro\u00dfhandel & B2B-Vertrieb", desc: "Handel, Distribution, B2B-Vertriebsorganisationen" },
        { name: "Logistik & Supply Chain", desc: "Transport, Lagerhaltung, Planung" },
        { name: "Produktion & Industrie", desc: "Fertigung, Montage, Qualit\u00e4tskontrolle" },
        { name: "Bau & Technischer Service", desc: "Installation, Wartung, Projekte" },
        { name: "HR & Recruitment", desc: "Rekrutierung, Auswahl, Onboarding" },
      ],
    },
    cta: {
      title: "Bereit, KI praktisch einzusetzen?",
      subtitle: "Fordern Sie einen kostenlosen KI Quick Scan an. In 2-3 Wochen zeigen wir, wo KI sofortige Rendite liefert.",
      benefits: ["Kostenloses und unverbindliches Gespr\u00e4ch", "Top-10 KI-Chancen f\u00fcr Ihre Organisation", "Erwartete Zeitersparnis pro Prozess", "Konkrete 90-Tage-Roadmap"],
      button: "Kostenlosen KI-Scan starten",
    },
    auth: {
      login_title: "Willkommen zur\u00fcck", login_subtitle: "Melden Sie sich bei Ihrem CleverTion-Konto an",
      register_title: "Konto erstellen", register_subtitle: "Starten Sie Ihre KI-Transformation",
      email: "E-Mail-Adresse", password: "Passwort", name: "Vollst\u00e4ndiger Name",
      login_btn: "Anmelden", register_btn: "Registrieren", google_btn: "Weiter mit Google",
      no_account: "Noch kein Konto?", has_account: "Bereits ein Konto?", or: "oder",
    },
    dashboard: {
      title: "Mein Dashboard", tab_overview: "\u00dcbersicht", tab_intakes: "Meine Anfragen", tab_reports: "Berichte",
      welcome: "Willkommen", no_intakes: "Noch keine Anfragen. W\u00e4hlen Sie einen Dienst.", no_reports: "Noch keine Berichte verf\u00fcgbar.",
      choose_service: "W\u00e4hlen Sie einen Dienst", status: "Status", payment: "Zahlung", report: "Bericht",
      view_report: "Bericht ansehen", generate_report: "Bericht generieren", pay_now: "Jetzt bezahlen",
      generating: "Bericht wird generiert...", paid: "Bezahlt", pending: "Ausstehend",
      submitted: "Eingereicht", completed: "Abgeschlossen", not_started: "Nicht gestartet",
    },
    intake: {
      title: "Intake-Formular", submit: "Anfrage absenden", submitting: "Wird gesendet...",
      required: "Dieses Feld ist erforderlich", select_placeholder: "Ausw\u00e4hlen...",
      success: "Ihre Anfrage wurde erfolgreich eingereicht!", proceed_payment: "Zur Zahlung", back: "Zur\u00fcck zum Dashboard",
    },
    admin: {
      title: "Admin Dashboard", tab_stats: "Statistiken", tab_clients: "Kunden", tab_pipeline: "CRM Pipeline",
      tab_intakes: "Anfragen", tab_reports: "Berichte", tab_payments: "Zahlungen",
      total_clients: "Gesamt Kunden", active_clients: "Aktive Kunden", blocked_clients: "Gesperrte Kunden",
      total_intakes: "Gesamt Anfragen", paid_intakes: "Bezahlte Anfragen", total_reports: "Gesamt Berichte",
      total_revenue: "Gesamtumsatz", block: "Sperren", accept: "Akzeptieren", blocked: "Gesperrt", active: "Aktiv",
      move_to: "Verschieben nach",
      stages: { lead: "Lead", quick_scan: "Quick Scan", pilot: "Pilot", workflow: "Workflow", training: "Training", governance: "Governance" },
    },
    payment: {
      checking: "Zahlungsstatus wird \u00fcberpr\u00fcft...", success: "Zahlung erfolgreich!",
      success_msg: "Ihre Zahlung wurde empfangen. Sie k\u00f6nnen jetzt Ihren Bericht generieren lassen.",
      failed: "Zahlung fehlgeschlagen", failed_msg: "Es gab ein Problem mit Ihrer Zahlung. Bitte versuchen Sie es erneut.",
      go_dashboard: "Zum Dashboard",
    },
    footer: { tagline: "KI f\u00fcr mittelst\u00e4ndische Unternehmen", rights: "Alle Rechte vorbehalten." },
  },
  fr: {
    nav: { services: "Services", dashboard: "Tableau de bord", admin: "Admin", login: "Connexion", register: "S'inscrire", logout: "D\u00e9connexion" },
    hero: {
      badge: "33% des entreprises NL utilisent d\u00e9j\u00e0 l'IA \u2014 et vous?",
      title: "Des exp\u00e9riences IA isol\u00e9es \u00e0 des processus fonctionnels",
      subtitle: "Nous aidons les entreprises de taille moyenne \u00e0 int\u00e9grer l'IA dans leurs processus existants.",
      cta_scan: "Demander un Scan IA Gratuit",
      cta_services: "Voir nos services",
      stat_ai: "des entreprises NL utilisent l'IA",
      stat_days: "jusqu'aux r\u00e9sultats mesurables",
      stat_fte: "ETP groupe cible",
      stat_exp: "ans d'exp\u00e9rience internationale",
    },
    services: { title: "Nos Services", subtitle: "Solutions IA pratiques avec des r\u00e9sultats imm\u00e9diats", start_intake: "D\u00e9marrer l'intake", per_project: "par projet" },
    approach: {
      title: "Notre Approche", subtitle: "Trois promesses, un objectif: rendre votre entreprise plus intelligente",
      promise1_title: "Travailler plus efficacement", promise1_desc: "Nous \u00e9liminons le travail de bureau r\u00e9p\u00e9titif des processus.",
      promise2_title: "Cro\u00eetre commercialement plus vite", promise2_desc: "Les \u00e9quipes commerciales r\u00e9agissent plus vite et tirent plus des donn\u00e9es clients.",
      promise3_title: "Contr\u00f4le et standardisation", promise3_desc: "Les connaissances, m\u00e9thodes et communications deviennent plus coh\u00e9rentes avec l'IA.",
      usecases_title: "10 cas d'utilisation que chaque entreprise comprend",
      usecases: ["R\u00e9sumer et prioriser les e-mails", "R\u00e9diger des devis et propositions plus rapidement", "Cat\u00e9goriser automatiquement les demandes clients", "Base de connaissances interne / Assistant IA", "Cr\u00e9er des rapports et r\u00e9sum\u00e9s", "Lire des documents et transf\u00e9rer des donn\u00e9es", "Notes CRM et suivi commercial", "G\u00e9n\u00e9rer des comptes rendus et points d'action", "Descriptions de postes et mat\u00e9riel d'int\u00e9gration", "Analyser contrats et documents de politique"],
    },
    sectors: {
      title: "Secteurs", subtitle: "O\u00f9 l'IA offre les r\u00e9sultats les plus rapides",
      items: [
        { name: "Services aux entreprises", desc: "Conseil, comptabilit\u00e9, juridique, RH" },
        { name: "Commerce de gros & Ventes B2B", desc: "Commerce, distribution, organisations de vente B2B" },
        { name: "Logistique & Supply Chain", desc: "Transport, entreposage, planification" },
        { name: "Production & Industrie", desc: "Fabrication, assemblage, contr\u00f4le qualit\u00e9" },
        { name: "Construction & Service Technique", desc: "Installation, maintenance, projets" },
        { name: "RH & Recrutement", desc: "Recrutement, s\u00e9lection, int\u00e9gration" },
      ],
    },
    cta: {
      title: "Pr\u00eat \u00e0 mettre l'IA au travail?",
      subtitle: "Demandez un Scan IA Quick gratuit. En 2-3 semaines, nous montrons o\u00f9 l'IA g\u00e9n\u00e8re un rendement imm\u00e9diat.",
      benefits: ["Consultation gratuite et sans engagement", "Top 10 des opportunit\u00e9s IA pour votre organisation", "Gains de temps attendus par processus", "Feuille de route concr\u00e8te de 90 jours"],
      button: "D\u00e9marrer votre Scan IA Gratuit",
    },
    auth: {
      login_title: "Bon retour", login_subtitle: "Connectez-vous \u00e0 votre compte CleverTion",
      register_title: "Cr\u00e9er un compte", register_subtitle: "D\u00e9marrez votre transformation IA",
      email: "Adresse e-mail", password: "Mot de passe", name: "Nom complet",
      login_btn: "Se connecter", register_btn: "S'inscrire", google_btn: "Continuer avec Google",
      no_account: "Pas encore de compte?", has_account: "D\u00e9j\u00e0 un compte?", or: "ou",
    },
    dashboard: {
      title: "Mon Tableau de bord", tab_overview: "Aper\u00e7u", tab_intakes: "Mes demandes", tab_reports: "Rapports",
      welcome: "Bienvenue", no_intakes: "Pas encore de demandes. Choisissez un service.", no_reports: "Aucun rapport disponible.",
      choose_service: "Choisissez un service", status: "Statut", payment: "Paiement", report: "Rapport",
      view_report: "Voir le rapport", generate_report: "G\u00e9n\u00e9rer le rapport", pay_now: "Payer maintenant",
      generating: "G\u00e9n\u00e9ration du rapport...", paid: "Pay\u00e9", pending: "En attente",
      submitted: "Soumis", completed: "Termin\u00e9", not_started: "Non commenc\u00e9",
    },
    intake: {
      title: "Formulaire d'intake", submit: "Soumettre la demande", submitting: "Envoi en cours...",
      required: "Ce champ est obligatoire", select_placeholder: "S\u00e9lectionner...",
      success: "Votre demande a \u00e9t\u00e9 soumise avec succ\u00e8s!", proceed_payment: "Proc\u00e9der au paiement", back: "Retour au tableau de bord",
    },
    admin: {
      title: "Tableau de bord Admin", tab_stats: "Statistiques", tab_clients: "Clients", tab_pipeline: "Pipeline CRM",
      tab_intakes: "Demandes", tab_reports: "Rapports", tab_payments: "Paiements",
      total_clients: "Total clients", active_clients: "Clients actifs", blocked_clients: "Clients bloqu\u00e9s",
      total_intakes: "Total demandes", paid_intakes: "Demandes pay\u00e9es", total_reports: "Total rapports",
      total_revenue: "Revenu total", block: "Bloquer", accept: "Accepter", blocked: "Bloqu\u00e9", active: "Actif",
      move_to: "D\u00e9placer vers",
      stages: { lead: "Lead", quick_scan: "Quick Scan", pilot: "Pilot", workflow: "Workflow", training: "Formation", governance: "Gouvernance" },
    },
    payment: {
      checking: "V\u00e9rification du statut de paiement...", success: "Paiement r\u00e9ussi!",
      success_msg: "Votre paiement a \u00e9t\u00e9 re\u00e7u. Vous pouvez maintenant g\u00e9n\u00e9rer votre rapport.",
      failed: "Paiement \u00e9chou\u00e9", failed_msg: "Un probl\u00e8me est survenu avec votre paiement. Veuillez r\u00e9essayer.",
      go_dashboard: "Aller au tableau de bord",
    },
    footer: { tagline: "IA intelligente en action pour votre entreprise", rights: "Tous droits r\u00e9serv\u00e9s." },
  },
  es: {
    nav: { services: "Servicios", dashboard: "Panel", admin: "Admin", login: "Iniciar sesi\u00f3n", register: "Registrarse", logout: "Cerrar sesi\u00f3n" },
    hero: {
      badge: "33% de las empresas NL ya usan IA \u2014 \u00bfy usted?",
      title: "De experimentos IA aislados a procesos funcionales",
      subtitle: "Ayudamos a empresas medianas a integrar la IA en sus procesos de trabajo existentes.",
      cta_scan: "Solicitar un Scan IA Gratis",
      cta_services: "Ver nuestros servicios",
      stat_ai: "de empresas NL usan IA", stat_days: "hasta resultados medibles", stat_fte: "ETC grupo objetivo", stat_exp: "a\u00f1os de experiencia internacional",
    },
    services: { title: "Nuestros Servicios", subtitle: "Soluciones IA pr\u00e1cticas con resultados inmediatos", start_intake: "Iniciar Intake", per_project: "por proyecto" },
    approach: {
      title: "Nuestro Enfoque", subtitle: "Tres promesas, un objetivo: hacer su empresa m\u00e1s inteligente",
      promise1_title: "Trabajar m\u00e1s eficientemente", promise1_desc: "Eliminamos el trabajo de oficina repetitivo de los procesos.",
      promise2_title: "Crecer comercialmente m\u00e1s r\u00e1pido", promise2_desc: "Los equipos comerciales responden m\u00e1s r\u00e1pido y obtienen m\u00e1s de los datos de clientes.",
      promise3_title: "Control y estandarizaci\u00f3n", promise3_desc: "El conocimiento y la comunicaci\u00f3n se vuelven m\u00e1s consistentes con la IA.",
      usecases_title: "10 casos de uso que toda empresa entiende",
      usecases: ["Resumir y priorizar emails", "Redactar presupuestos m\u00e1s r\u00e1pido", "Categorizar consultas autom\u00e1ticamente", "Base de conocimiento / Asistente IA", "Crear informes y res\u00famenes", "Leer documentos y transferir datos", "Notas CRM y seguimiento comercial", "Generar actas y puntos de acci\u00f3n", "Descripciones de puestos y onboarding", "Analizar contratos y pol\u00edticas"],
    },
    sectors: {
      title: "Sectores", subtitle: "Donde la IA ofrece resultados m\u00e1s r\u00e1pidos",
      items: [
        { name: "Servicios Empresariales", desc: "Consultor\u00eda, contabilidad, legal, RRHH" },
        { name: "Mayorista & Ventas B2B", desc: "Comercio, distribuci\u00f3n, organizaciones B2B" },
        { name: "Log\u00edstica & Supply Chain", desc: "Transporte, almacenamiento, planificaci\u00f3n" },
        { name: "Producci\u00f3n & Industria", desc: "Fabricaci\u00f3n, ensamblaje, control de calidad" },
        { name: "Construcci\u00f3n & Servicio T\u00e9cnico", desc: "Instalaci\u00f3n, mantenimiento, proyectos" },
        { name: "RRHH & Reclutamiento", desc: "Selecci\u00f3n, contrataci\u00f3n, onboarding" },
      ],
    },
    cta: {
      title: "\u00bfListo para poner la IA a trabajar?",
      subtitle: "Solicite un Scan IA Quick gratuito. En 2-3 semanas mostramos d\u00f3nde la IA genera rendimiento inmediato.",
      benefits: ["Consulta gratuita y sin compromiso", "Top 10 oportunidades IA para su organizaci\u00f3n", "Ahorro de tiempo esperado por proceso", "Hoja de ruta concreta de 90 d\u00edas"],
      button: "Inicie su Scan IA Gratis",
    },
    auth: {
      login_title: "Bienvenido de vuelta", login_subtitle: "Inicie sesi\u00f3n en su cuenta CleverTion",
      register_title: "Crear cuenta", register_subtitle: "Inicie su transformaci\u00f3n IA",
      email: "Correo electr\u00f3nico", password: "Contrase\u00f1a", name: "Nombre completo",
      login_btn: "Iniciar sesi\u00f3n", register_btn: "Registrarse", google_btn: "Continuar con Google",
      no_account: "\u00bfNo tiene cuenta?", has_account: "\u00bfYa tiene cuenta?", or: "o",
    },
    dashboard: {
      title: "Mi Panel", tab_overview: "Resumen", tab_intakes: "Mis Solicitudes", tab_reports: "Informes",
      welcome: "Bienvenido", no_intakes: "No tiene solicitudes a\u00fan.", no_reports: "No hay informes disponibles.",
      choose_service: "Elija un servicio", status: "Estado", payment: "Pago", report: "Informe",
      view_report: "Ver Informe", generate_report: "Generar Informe", pay_now: "Pagar ahora",
      generating: "Generando informe...", paid: "Pagado", pending: "Pendiente",
      submitted: "Enviado", completed: "Completado", not_started: "No iniciado",
    },
    intake: {
      title: "Formulario de Intake", submit: "Enviar Solicitud", submitting: "Enviando...",
      required: "Este campo es obligatorio", select_placeholder: "Seleccionar...",
      success: "\u00a1Su solicitud ha sido enviada con \u00e9xito!", proceed_payment: "Proceder al pago", back: "Volver al panel",
    },
    admin: {
      title: "Panel de Admin", tab_stats: "Estad\u00edsticas", tab_clients: "Clientes", tab_pipeline: "Pipeline CRM",
      tab_intakes: "Solicitudes", tab_reports: "Informes", tab_payments: "Pagos",
      total_clients: "Total clientes", active_clients: "Clientes activos", blocked_clients: "Clientes bloqueados",
      total_intakes: "Total solicitudes", paid_intakes: "Solicitudes pagadas", total_reports: "Total informes",
      total_revenue: "Ingresos totales", block: "Bloquear", accept: "Aceptar", blocked: "Bloqueado", active: "Activo",
      move_to: "Mover a",
      stages: { lead: "Lead", quick_scan: "Quick Scan", pilot: "Pilot", workflow: "Workflow", training: "Formaci\u00f3n", governance: "Gobernanza" },
    },
    payment: {
      checking: "Verificando estado del pago...", success: "\u00a1Pago exitoso!",
      success_msg: "Su pago ha sido recibido. Ahora puede generar su informe.",
      failed: "Pago fallido", failed_msg: "Hubo un problema con su pago. Int\u00e9ntelo de nuevo.",
      go_dashboard: "Ir al Panel",
    },
    footer: { tagline: "IA inteligente en acción para su empresa", rights: "Todos los derechos reservados." },
  },
  ar: {
    nav: { services: "\u0627\u0644\u062e\u062f\u0645\u0627\u062a", dashboard: "\u0644\u0648\u062d\u0629 \u0627\u0644\u062a\u062d\u0643\u0645", admin: "\u0627\u0644\u0625\u062f\u0627\u0631\u0629", login: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644", register: "\u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628", logout: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062e\u0631\u0648\u062c" },
    hero: {
      badge: "33% \u0645\u0646 \u0627\u0644\u0634\u0631\u0643\u0627\u062a \u0627\u0644\u0647\u0648\u0644\u0646\u062f\u064a\u0629 \u062a\u0633\u062a\u062e\u062f\u0645 \u0628\u0627\u0644\u0641\u0639\u0644 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a \u2014 \u0648\u0623\u0646\u062a\u061f",
      title: "\u0645\u0646 \u062a\u062c\u0627\u0631\u0628 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a \u0627\u0644\u0645\u0646\u0641\u0635\u0644\u0629 \u0625\u0644\u0649 \u0639\u0645\u0644\u064a\u0627\u062a \u0641\u0639\u0627\u0644\u0629",
      subtitle: "\u0646\u0633\u0627\u0639\u062f \u0627\u0644\u0634\u0631\u0643\u0627\u062a \u0627\u0644\u0645\u062a\u0648\u0633\u0637\u0629 \u0639\u0644\u0649 \u062f\u0645\u062c \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a \u0639\u0645\u0644\u064a\u0627\u064b \u0641\u064a \u0639\u0645\u0644\u064a\u0627\u062a \u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u062d\u0627\u0644\u064a\u0629.",
      cta_scan: "\u0627\u0637\u0644\u0628 \u0645\u0633\u062d AI \u0645\u062c\u0627\u0646\u064a",
      cta_services: "\u0639\u0631\u0636 \u062e\u062f\u0645\u0627\u062a\u0646\u0627",
      stat_ai: "\u0645\u0646 \u0627\u0644\u0634\u0631\u0643\u0627\u062a \u062a\u0633\u062a\u062e\u062f\u0645 AI", stat_days: "\u062d\u062a\u0649 \u0646\u062a\u0627\u0626\u062c \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0642\u064a\u0627\u0633", stat_fte: "\u0645\u0648\u0638\u0641 \u0645\u062c\u0645\u0648\u0639\u0629 \u0645\u0633\u062a\u0647\u062f\u0641\u0629", stat_exp: "\u0633\u0646\u0629 \u062e\u0628\u0631\u0629 \u062f\u0648\u0644\u064a\u0629",
    },
    services: { title: "\u062e\u062f\u0645\u0627\u062a\u0646\u0627", subtitle: "\u062d\u0644\u0648\u0644 \u0630\u0643\u0627\u0621 \u0627\u0635\u0637\u0646\u0627\u0639\u064a \u0639\u0645\u0644\u064a\u0629 \u0628\u0646\u062a\u0627\u0626\u062c \u0641\u0648\u0631\u064a\u0629", start_intake: "\u0628\u062f\u0621 \u0627\u0644\u0637\u0644\u0628", per_project: "\u0644\u0643\u0644 \u0645\u0634\u0631\u0648\u0639" },
    approach: {
      title: "\u0646\u0647\u062c\u0646\u0627", subtitle: "\u062b\u0644\u0627\u062b\u0629 \u0648\u0639\u0648\u062f\u060c \u0647\u062f\u0641 \u0648\u0627\u062d\u062f: \u062c\u0639\u0644 \u0634\u0631\u0643\u062a\u0643 \u062a\u0639\u0645\u0644 \u0628\u0630\u0643\u0627\u0621",
      promise1_title: "\u0627\u0644\u0639\u0645\u0644 \u0628\u0643\u0641\u0627\u0621\u0629 \u0623\u0643\u0628\u0631", promise1_desc: "\u0646\u0632\u064a\u0644 \u0627\u0644\u0639\u0645\u0644 \u0627\u0644\u0645\u0643\u062a\u0628\u064a \u0627\u0644\u0645\u062a\u0643\u0631\u0631 \u0645\u0646 \u0627\u0644\u0639\u0645\u0644\u064a\u0627\u062a.",
      promise2_title: "\u0627\u0644\u0646\u0645\u0648 \u0627\u0644\u062a\u062c\u0627\u0631\u064a \u0623\u0633\u0631\u0639", promise2_desc: "\u0641\u0631\u0642 \u0627\u0644\u0645\u0628\u064a\u0639\u0627\u062a \u062a\u0633\u062a\u062c\u064a\u0628 \u0623\u0633\u0631\u0639 \u0648\u062a\u0633\u062a\u0641\u064a\u062f \u0623\u0643\u062b\u0631 \u0645\u0646 \u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0639\u0645\u0644\u0627\u0621.",
      promise3_title: "\u0627\u0644\u062a\u062d\u0643\u0645 \u0648\u0627\u0644\u062a\u0648\u062d\u064a\u062f", promise3_desc: "\u0627\u0644\u0645\u0639\u0631\u0641\u0629 \u0648\u0627\u0644\u062a\u0648\u0627\u0635\u0644 \u062a\u0635\u0628\u062d \u0623\u0643\u062b\u0631 \u0627\u062a\u0633\u0627\u0642\u0627\u064b \u0645\u0639 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a.",
      usecases_title: "10 \u062d\u0627\u0644\u0627\u062a \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u062a\u0641\u0647\u0645\u0647\u0627 \u0643\u0644 \u0634\u0631\u0643\u0629",
      usecases: ["\u062a\u0644\u062e\u064a\u0635 \u0648\u062a\u0631\u062a\u064a\u0628 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a", "\u0625\u0639\u062f\u0627\u062f \u0627\u0644\u0639\u0631\u0648\u0636 \u0628\u0634\u0643\u0644 \u0623\u0633\u0631\u0639", "\u062a\u0635\u0646\u064a\u0641 \u0627\u0633\u062a\u0641\u0633\u0627\u0631\u0627\u062a \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u062a\u0644\u0642\u0627\u0626\u064a\u0627\u064b", "\u0642\u0627\u0639\u062f\u0629 \u0645\u0639\u0631\u0641\u064a\u0629 / \u0645\u0633\u0627\u0639\u062f AI", "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062a\u0642\u0627\u0631\u064a\u0631 \u0648\u0627\u0644\u0645\u0644\u062e\u0635\u0627\u062a", "\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0645\u0633\u062a\u0646\u062f\u0627\u062a \u0648\u0646\u0642\u0644 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a", "\u0645\u0644\u0627\u062d\u0638\u0627\u062a CRM \u0648\u0645\u062a\u0627\u0628\u0639\u0629 \u0627\u0644\u0645\u0628\u064a\u0639\u0627\u062a", "\u0625\u0646\u0634\u0627\u0621 \u0645\u062d\u0627\u0636\u0631 \u0627\u0644\u0627\u062c\u062a\u0645\u0627\u0639\u0627\u062a \u0648\u0646\u0642\u0627\u0637 \u0627\u0644\u0639\u0645\u0644", "\u0648\u0635\u0641 \u0627\u0644\u0648\u0638\u0627\u0626\u0641 \u0648\u0645\u0648\u0627\u062f \u0627\u0644\u062a\u0623\u0647\u064a\u0644", "\u062a\u062d\u0644\u064a\u0644 \u0627\u0644\u0639\u0642\u0648\u062f \u0648\u0648\u062b\u0627\u0626\u0642 \u0627\u0644\u0633\u064a\u0627\u0633\u0627\u062a"],
    },
    sectors: {
      title: "\u0627\u0644\u0642\u0637\u0627\u0639\u0627\u062a", subtitle: "\u062d\u064a\u062b \u064a\u0642\u062f\u0645 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a \u0623\u0633\u0631\u0639 \u0627\u0644\u0646\u062a\u0627\u0626\u062c",
      items: [
        { name: "\u0627\u0644\u062e\u062f\u0645\u0627\u062a \u0627\u0644\u062a\u062c\u0627\u0631\u064a\u0629", desc: "\u0627\u0644\u0627\u0633\u062a\u0634\u0627\u0631\u0627\u062a\u060c \u0627\u0644\u0645\u062d\u0627\u0633\u0628\u0629\u060c \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064a\u0629\u060c \u0627\u0644\u0645\u0648\u0627\u0631\u062f \u0627\u0644\u0628\u0634\u0631\u064a\u0629" },
        { name: "\u0627\u0644\u062c\u0645\u0644\u0629 \u0648\u0645\u0628\u064a\u0639\u0627\u062a B2B", desc: "\u0627\u0644\u062a\u062c\u0627\u0631\u0629\u060c \u0627\u0644\u062a\u0648\u0632\u064a\u0639\u060c \u0645\u0646\u0638\u0645\u0627\u062a \u0627\u0644\u0645\u0628\u064a\u0639\u0627\u062a" },
        { name: "\u0627\u0644\u0644\u0648\u062c\u0633\u062a\u064a\u0627\u062a \u0648\u0633\u0644\u0633\u0644\u0629 \u0627\u0644\u062a\u0648\u0631\u064a\u062f", desc: "\u0627\u0644\u0646\u0642\u0644\u060c \u0627\u0644\u062a\u062e\u0632\u064a\u0646\u060c \u0627\u0644\u062a\u062e\u0637\u064a\u0637" },
        { name: "\u0627\u0644\u062a\u0635\u0646\u064a\u0639 \u0648\u0627\u0644\u0635\u0646\u0627\u0639\u0629", desc: "\u0627\u0644\u0625\u0646\u062a\u0627\u062c\u060c \u0627\u0644\u062a\u062c\u0645\u064a\u0639\u060c \u0645\u0631\u0627\u0642\u0628\u0629 \u0627\u0644\u062c\u0648\u062f\u0629" },
        { name: "\u0627\u0644\u0628\u0646\u0627\u0621 \u0648\u0627\u0644\u062e\u062f\u0645\u0627\u062a \u0627\u0644\u062a\u0642\u0646\u064a\u0629", desc: "\u0627\u0644\u062a\u0631\u0643\u064a\u0628\u060c \u0627\u0644\u0635\u064a\u0627\u0646\u0629\u060c \u0627\u0644\u0645\u0634\u0627\u0631\u064a\u0639" },
        { name: "\u0627\u0644\u0645\u0648\u0627\u0631\u062f \u0627\u0644\u0628\u0634\u0631\u064a\u0629 \u0648\u0627\u0644\u062a\u0648\u0638\u064a\u0641", desc: "\u0627\u0644\u062a\u0648\u0638\u064a\u0641\u060c \u0627\u0644\u0627\u062e\u062a\u064a\u0627\u0631\u060c \u0627\u0644\u062a\u0623\u0647\u064a\u0644" },
      ],
    },
    cta: {
      title: "\u0647\u0644 \u0623\u0646\u062a \u0645\u0633\u062a\u0639\u062f \u0644\u062a\u0634\u063a\u064a\u0644 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a\u061f",
      subtitle: "\u0627\u0637\u0644\u0628 \u0645\u0633\u062d AI \u0645\u062c\u0627\u0646\u064a. \u0641\u064a 2-3 \u0623\u0633\u0627\u0628\u064a\u0639 \u0646\u0648\u0636\u062d \u0623\u064a\u0646 \u064a\u062d\u0642\u0642 AI \u0639\u0648\u0627\u0626\u062f \u0641\u0648\u0631\u064a\u0629.",
      benefits: ["\u0627\u0633\u062a\u0634\u0627\u0631\u0629 \u0645\u062c\u0627\u0646\u064a\u0629 \u0648\u063a\u064a\u0631 \u0645\u0644\u0632\u0645\u0629", "\u0623\u0641\u0636\u0644 10 \u0641\u0631\u0635 AI \u0644\u0645\u0646\u0638\u0645\u062a\u0643", "\u062a\u0648\u0641\u064a\u0631 \u0627\u0644\u0648\u0642\u062a \u0627\u0644\u0645\u062a\u0648\u0642\u0639 \u0644\u0643\u0644 \u0639\u0645\u0644\u064a\u0629", "\u062e\u0627\u0631\u0637\u0629 \u0637\u0631\u064a\u0642 \u0639\u0645\u0644\u064a\u0629 \u0644\u0640 90 \u064a\u0648\u0645\u0627\u064b"],
      button: "\u0627\u0628\u062f\u0623 \u0645\u0633\u062d AI \u0627\u0644\u0645\u062c\u0627\u0646\u064a",
    },
    auth: {
      login_title: "\u0645\u0631\u062d\u0628\u0627\u064b \u0628\u0639\u0648\u062f\u062a\u0643", login_subtitle: "\u0633\u062c\u0644 \u0627\u0644\u062f\u062e\u0648\u0644 \u0625\u0644\u0649 \u062d\u0633\u0627\u0628\u0643 CleverTion",
      register_title: "\u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628", register_subtitle: "\u0627\u0628\u062f\u0623 \u062a\u062d\u0648\u0644\u0643 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064a",
      email: "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a", password: "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631", name: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
      login_btn: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062f\u062e\u0648\u0644", register_btn: "\u0625\u0646\u0634\u0627\u0621 \u062d\u0633\u0627\u0628", google_btn: "\u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 Google",
      no_account: "\u0644\u064a\u0633 \u0644\u062f\u064a\u0643 \u062d\u0633\u0627\u0628\u061f", has_account: "\u0644\u062f\u064a\u0643 \u062d\u0633\u0627\u0628 \u0628\u0627\u0644\u0641\u0639\u0644\u061f", or: "\u0623\u0648",
    },
    dashboard: {
      title: "\u0644\u0648\u062d\u0629 \u0627\u0644\u062a\u062d\u0643\u0645", tab_overview: "\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629", tab_intakes: "\u0637\u0644\u0628\u0627\u062a\u064a", tab_reports: "\u0627\u0644\u062a\u0642\u0627\u0631\u064a\u0631",
      welcome: "\u0645\u0631\u062d\u0628\u0627\u064b", no_intakes: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0637\u0644\u0628\u0627\u062a \u0628\u0639\u062f.", no_reports: "\u0644\u0627 \u062a\u0648\u062c\u062f \u062a\u0642\u0627\u0631\u064a\u0631 \u0645\u062a\u0627\u062d\u0629.",
      choose_service: "\u0627\u062e\u062a\u0631 \u062e\u062f\u0645\u0629", status: "\u0627\u0644\u062d\u0627\u0644\u0629", payment: "\u0627\u0644\u062f\u0641\u0639", report: "\u0627\u0644\u062a\u0642\u0631\u064a\u0631",
      view_report: "\u0639\u0631\u0636 \u0627\u0644\u062a\u0642\u0631\u064a\u0631", generate_report: "\u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062a\u0642\u0631\u064a\u0631", pay_now: "\u0627\u062f\u0641\u0639 \u0627\u0644\u0622\u0646",
      generating: "\u062c\u0627\u0631\u064d \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u062a\u0642\u0631\u064a\u0631...", paid: "\u0645\u062f\u0641\u0648\u0639", pending: "\u0642\u064a\u062f \u0627\u0644\u0627\u0646\u062a\u0638\u0627\u0631",
      submitted: "\u0645\u064f\u0631\u0633\u0644", completed: "\u0645\u0643\u062a\u0645\u0644", not_started: "\u0644\u0645 \u064a\u0628\u062f\u0623",
    },
    intake: {
      title: "\u0646\u0645\u0648\u0630\u062c \u0627\u0644\u0637\u0644\u0628", submit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0637\u0644\u0628", submitting: "\u062c\u0627\u0631\u064d \u0627\u0644\u0625\u0631\u0633\u0627\u0644...",
      required: "\u0647\u0630\u0627 \u0627\u0644\u062d\u0642\u0644 \u0645\u0637\u0644\u0648\u0628", select_placeholder: "\u0627\u062e\u062a\u0631...",
      success: "\u062a\u0645 \u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628\u0643 \u0628\u0646\u062c\u0627\u062d!", proceed_payment: "\u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0644\u0644\u062f\u0641\u0639", back: "\u0627\u0644\u0639\u0648\u062f\u0629 \u0625\u0644\u0649 \u0644\u0648\u062d\u0629 \u0627\u0644\u062a\u062d\u0643\u0645",
    },
    admin: {
      title: "\u0644\u0648\u062d\u0629 \u0627\u0644\u0625\u062f\u0627\u0631\u0629", tab_stats: "\u0627\u0644\u0625\u062d\u0635\u0627\u0626\u064a\u0627\u062a", tab_clients: "\u0627\u0644\u0639\u0645\u0644\u0627\u0621", tab_pipeline: "\u062e\u0637 CRM",
      tab_intakes: "\u0627\u0644\u0637\u0644\u0628\u0627\u062a", tab_reports: "\u0627\u0644\u062a\u0642\u0627\u0631\u064a\u0631", tab_payments: "\u0627\u0644\u0645\u062f\u0641\u0648\u0639\u0627\u062a",
      total_clients: "\u0625\u062c\u0645\u0627\u0644\u064a \u0627\u0644\u0639\u0645\u0644\u0627\u0621", active_clients: "\u0639\u0645\u0644\u0627\u0621 \u0646\u0634\u0637\u0648\u0646", blocked_clients: "\u0639\u0645\u0644\u0627\u0621 \u0645\u062d\u0638\u0648\u0631\u0648\u0646",
      total_intakes: "\u0625\u062c\u0645\u0627\u0644\u064a \u0627\u0644\u0637\u0644\u0628\u0627\u062a", paid_intakes: "\u0637\u0644\u0628\u0627\u062a \u0645\u062f\u0641\u0648\u0639\u0629", total_reports: "\u0625\u062c\u0645\u0627\u0644\u064a \u0627\u0644\u062a\u0642\u0627\u0631\u064a\u0631",
      total_revenue: "\u0625\u062c\u0645\u0627\u0644\u064a \u0627\u0644\u0625\u064a\u0631\u0627\u062f\u0627\u062a", block: "\u062d\u0638\u0631", accept: "\u0642\u0628\u0648\u0644", blocked: "\u0645\u062d\u0638\u0648\u0631", active: "\u0646\u0634\u0637",
      move_to: "\u0646\u0642\u0644 \u0625\u0644\u0649",
      stages: { lead: "Lead", quick_scan: "Quick Scan", pilot: "Pilot", workflow: "Workflow", training: "\u062a\u062f\u0631\u064a\u0628", governance: "\u062d\u0648\u0643\u0645\u0629" },
    },
    payment: {
      checking: "\u062c\u0627\u0631\u064d \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0646 \u062d\u0627\u0644\u0629 \u0627\u0644\u062f\u0641\u0639...", success: "\u062a\u0645 \u0627\u0644\u062f\u0641\u0639 \u0628\u0646\u062c\u0627\u062d!",
      success_msg: "\u062a\u0645 \u0627\u0633\u062a\u0644\u0627\u0645 \u062f\u0641\u0639\u062a\u0643. \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u0622\u0646 \u0625\u0646\u0634\u0627\u0621 \u062a\u0642\u0631\u064a\u0631\u0643.",
      failed: "\u0641\u0634\u0644 \u0627\u0644\u062f\u0641\u0639", failed_msg: "\u062d\u062f\u062b\u062a \u0645\u0634\u0643\u0644\u0629 \u0641\u064a \u0627\u0644\u062f\u0641\u0639. \u064a\u0631\u062c\u0649 \u0627\u0644\u0645\u062d\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649.",
      go_dashboard: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0644\u0648\u062d\u0629 \u0627\u0644\u062a\u062d\u0643\u0645",
    },
    footer: { tagline: "\u0630\u0643\u0627\u0621 \u0627\u0635\u0637\u0646\u0627\u0639\u064a \u0644\u0644\u0634\u0631\u0643\u0627\u062a \u0627\u0644\u0645\u062a\u0648\u0633\u0637\u0629", rights: "\u062c\u0645\u064a\u0639 \u0627\u0644\u062d\u0642\u0648\u0642 \u0645\u062d\u0641\u0648\u0638\u0629." },
  },
};

export default translations;
